const Flickity = require('flickity');
const Masonry = require('masonry-layout');
import GLightbox from 'glightbox';
require('flickity-fullscreen');
require('flickity-imagesloaded');

export default () => {

    const grids = document.querySelectorAll('[data-gallery-grid]');
    for (const grid of grids) {
        const masonry = new Masonry( grid, {
            itemSelector: '.image-gallery__grid__item'
        });
    }

    const sliders = document.querySelectorAll('[data-gallery-slider]');
    for (const slider of sliders) {
        const flkty = new Flickity(slider, {
            cellAlign: 'left',
            imagesLoaded: true,
            wrapAround: true,
            freeScroll: false,
            freeScrollFriction: 0.03,
            pageDots: false,
            prevNextButtons: true // slider.children.length > 10
        });
    }

    const carousels = document.querySelectorAll('[data-gallery-carousel]');
    for (const carousel of carousels) {
        const flkty = new Flickity(carousel, {
            cellAlign: 'left',
            imagesLoaded: true,
            wrapAround: true,
            freeScroll: true,
            freeScrollFriction: 0.03,
            pageDots: carousel.children.length <= 10,
            prevNextButtons: true // slider.children.length > 10
        });
    }

    const images = document.querySelectorAll('[data-gallery-popup]');
    if (images.length) {
        GLightbox({
            selector: '[data-gallery-popup]',
        });
    }

}
